import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { TopicStore } from '../../../stores/topic/topic.state';
import { FormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

@Component({
  selector: 'app-topic-filter-dropdown',
  standalone: true,
  imports: [
    MultiSelectModule,
    NgIf,
    SharedModule,
    FormsModule,
    IconFieldModule,
    InputIconModule,
  ],
  templateUrl: './topic-filter-dropdown.component.html',
  styleUrl: './topic-filter-dropdown.component.scss',
})
export class TopicFilterDropdownComponent {
  readonly topicStore = inject(TopicStore);

  @Input() styleClass = '';
  @Input() label = 'Themen';
  @Input() selectedTopics?: string[] = [];
  @Output() selectedTopicsChange = new EventEmitter<string[]>();

  /**
   * Handles changes to the selected topics by emitting the updated list of topics after a short delay.
   *
   * @return {void} This method does not return a value.
   */
  onTopicsChange(): void {
    setTimeout(() => {
      this.selectedTopicsChange.emit(this.selectedTopics);
    }, 10);
  }
}
